// extracted by mini-css-extract-plugin
export default {"melodyVideo":"EK-z","isFullWidth":"FK-z","landingPageVideo":"GK-z","play":"HK-z","iframeVideo":"IK-z","playHidden":"JK-z","fullwidth":"KK-z"};